import React from 'react';
import SvgIcon from 'material-ui/SvgIcon';

let IconVote = (props) => {
  props = Object.assign({viewBox: '0 0 30 30'}, props);
  return (
    <SvgIcon {...props}>
      <g>
        <g>
          <path d="M29.1,11.8c-0.2-0.4-0.5-0.8-1.1-0.8h-9.2L16,2.5c-0.2-0.4-0.5-0.7-1.1-0.7l0,0c-0.4,0-0.9,0.3-1.1,0.7L11.1,11H1.9
			c-0.4,0-0.9,0.3-1.1,0.8c-0.2,0.4,0,1,0.4,1.2l7.5,5.3L6,26.8c-0.2,0.4,0,1,0.4,1.2c0.2,0.2,0.4,0.2,0.6,0.2
			c0.3,0,0.4-0.1,0.6-0.2l7.5-5.3l7.5,5.3c0.2,0.2,0.4,0.2,0.6,0.2c0.3,0,0.4-0.1,0.6-0.2c0.4-0.3,0.5-0.8,0.4-1.2l-2.8-8.5l7.5-5.3
			C29.1,12.8,29.3,12.2,29.1,11.8z M20.3,17.7c-0.2,0.2-0.3,0.4-0.2,0.6l3,8.9l-7.7-5.5c-0.1-0.1-0.2-0.1-0.4-0.1
			c-0.1,0-0.3,0-0.4,0.1L7,27.1l2.9-8.9c0.1-0.3,0-0.4-0.2-0.6l-7.8-5.5h9.6c0.3,0,0.4-0.2,0.5-0.4l3-8.9l3,8.9
			c0.1,0.3,0.3,0.4,0.5,0.4h9.6L20.3,17.7z"/>
        </g>
      </g>
    </SvgIcon>
  );
};

IconVote.displayName = 'IconVote';
IconVote.muiName = 'SvgIcon';

export default IconVote;



// WEBPACK FOOTER //
// ./src/components/Icons/IconVote.js